import { FaExclamationTriangle } from 'react-icons/fa';

const DuplicateWarningModal = ({
  duplicateJobInfo,
  onCancel,
  onDismiss,
  onProceed,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <h4 className="text-lg font-semibold mb-4 text-gray-800 flex items-center">
          <FaExclamationTriangle className="text-amber-500 mr-2" />
          Duplicate Job Warning
        </h4>
        <div className="mb-4">
          <p className="text-amber-700 bg-amber-50 p-3 rounded border border-amber-300">
            You already completed another <strong>{duplicateJobInfo.serviceType}</strong> job on{' '}
            <strong>{duplicateJobInfo.completionDate}</strong> for{' '}
            <strong>{duplicateJobInfo.clientName}</strong> at{' '}
            <strong>{duplicateJobInfo.address}</strong>.
          </p>
          <p className="mt-3 text-gray-700">
            This looks like a duplicate. Check the completion date, or complete anyway if this is a genuinely separate job.
          </p>
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onDismiss}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 border border-gray-300 rounded-md shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
          >
            Change Completion Date
          </button>
          <button
            onClick={onProceed}
            className="px-4 py-2 text-sm font-medium text-white bg-amber-500 border border-amber-600 rounded-md shadow-sm hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-400"
          >
            Complete Anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default DuplicateWarningModal;
